import { CloseOutlined, PlusOutlined } from '@ant-design/icons'
import React, { useRef, useState } from 'react'
import BargeTankSection from './sections/bargeTank/BargeTankSection'
import BunkerInfoSection from './sections/bunkerInfo/BunkerInfoSection'
import LaboratorySection from './sections/laboratory/LaboratorySection'
import { Modal } from 'antd'
import NavigationTab from 'components/NavigationTabs'
import { useTranslation } from 'react-i18next'

import './robBunkerTab.less'

const getBargeSections = t => [
  { key: 'bunkerInfo', label: t('rob.survey.bunker.bunkerInfo') },
  { key: 'bargeTank', label: t('rob.survey.bunker.bargeTank') },
  { key: 'laboratory', label: t('rob.survey.bunker.laboratory') },
]

const SECTION_CONTENT = {
  bargeTank: <BargeTankSection />,
  bunkerInfo: <BunkerInfoSection />,
  laboratory: <LaboratorySection />,
}

const RobBunkerTab = () => {
  const { t } = useTranslation()
  const idCounter = useRef(1)

  const [barges, setBarges] = useState([{ id: 'barge-1' }])
  const [activeBargeKey, setActiveBargeKey] = useState('barge-1')
  const [activeSectionMap, setActiveSectionMap] = useState({
    'barge-1': 'bunkerInfo',
  })

  const handleAddBarge = () => {
    idCounter.current += 1
    const newId = `barge-${idCounter.current}`
    setBarges(prev => [...prev, { id: newId }])
    setActiveBargeKey(newId)
    setActiveSectionMap(prev => ({ ...prev, [newId]: 'bunkerInfo' }))
  }

  const confirmRemoveBarge = bargeId => {
    Modal.confirm({
      cancelText: t('global.no'),
      content: t('rob.survey.bunker.removeBargeConfirm'),
      okText: t('global.yes'),
      onOk: () => {
        setBarges(prev => {
          const updated = prev.filter(b => b.id !== bargeId)
          if (activeBargeKey === bargeId && updated.length > 0) {
            setActiveBargeKey(updated[updated.length - 1].id)
          }

          return updated
        })
        setActiveSectionMap(prev => {
          const next = { ...prev }
          delete next[bargeId]

          return next
        })
      },
      title: t('rob.survey.bunker.removeBargeTitle'),
    })
  }

  const handleSectionChange = sectionKey => {
    setActiveSectionMap(prev => ({ ...prev, [activeBargeKey]: sectionKey }))
  }

  const activeSection = activeSectionMap[activeBargeKey] || 'bunkerInfo'
  const bargeSections = getBargeSections(t)

  return (
    <div className="rob-bunker__container">
      <div className="rob-bunker__barge-row">
        <div className="rob-bunker__barge-selector">
          {barges.map((barge, index) => (
            <button
              key={barge.id}
              onClick={() => setActiveBargeKey(barge.id)}
              type="button"
              className={`rob-bunker__barge-card${
                activeBargeKey === barge.id
                  ? ' rob-bunker__barge-card--active'
                  : ''
              }`}
            >
              {t('rob.survey.bunker.bargeLabel', { number: index + 1 })}
              {barges.length > 1 && (
                <CloseOutlined
                  className="rob-bunker__barge-card-close"
                  onClick={e => {
                    e.stopPropagation()
                    confirmRemoveBarge(barge.id)
                  }}
                />
              )}
            </button>
          ))}
          <button
            className="rob-bunker__barge-add"
            onClick={handleAddBarge}
            type="button"
          >
            <PlusOutlined />
          </button>
        </div>
      </div>

      <div className="rob-bunker__sections-panel">
        <NavigationTab
          activeKey={activeSection}
          className="rob-bunker__section-tabs"
          items={bargeSections}
          onTabChange={handleSectionChange}
        />
        <div className="rob-bunker__section-content">
          {Object.entries(SECTION_CONTENT).map(([key, content]) => (
            <div
              key={key}
              style={key !== activeSection ? { display: 'none' } : undefined}
            >
              {content}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default RobBunkerTab
